import React from "react";
import { Bar, HorizontalBar } from "react-chartjs-2";

export const BarChart = ({ chartData, indexAxis }) => {

  return (
    <div className="chart-container">
      {indexAxis === 'x' ?
        <Bar
          data={chartData}
          options={{
            plugins: {
              title: {
                display: true,
              },
              legend: {
                display: true,
                position: 'right',
              }
            }
          }}
        />
        :
        <HorizontalBar
          data={chartData}
          options={{
            plugins: {
              title: {
                display: true,
              },
              legend: {
                display: true,
                position: 'right',
              }
            }
          }}
        />
      }
    </div>
  );
};

export default BarChart;